import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { addClass, removeClass, disableElement, enableElement } from '@fretadao/f-js-dom';
import { isBlank } from '@fretadao/f-js-utils';

application.register(
  'dependant-toggle',
  class extends Controller {
    static targets = ['dependant', 'ingoing', 'outgoing', 'ingoingContainer', 'outgoingContainer'];

    connect() {
      this.toggle();
    }

    toggle(_event) {
      if (this.dependantTarget.value === 'ingoing') {
        this.#disableTarget(this.outgoingTarget);
        this.#enableTarget(this.ingoingTarget);
      } else if (this.dependantTarget.value === 'outgoing') {
        this.#disableTarget(this.ingoingTarget);
        this.#enableTarget(this.outgoingTarget);
      } else if (isBlank(this.dependantTarget.value)) {
        this.#disableTargets([this.ingoingTarget, this.outgoingTarget]);
      } else {
        this.#enableTargets([this.ingoingTarget, this.outgoingTarget]);
      }
    }

    #disableTarget(target) {
      this.#disableTargets([target]);
    }

    #enableTarget(target) {
      this.#enableTargets([target]);
    }

    #disableTargets(targets) {
      targets.forEach(target => {
        disableElement(target);
        addClass(target, 'bg-gray-lt');
        target.value = null;
      });
    }

    #enableTargets(targets) {
      targets.forEach(target => {
        enableElement(target);
        removeClass(target, 'bg-gray-lt');
      });
    }
  }
);
